import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RefundPolicyActions } from "../../../../redux/actions";
import { useForm, Controller } from "react-hook-form";
import { translationConstants } from "../../../../constants";
import { Direction } from "react-data-table-component";
import { allowOnlyNumbers } from "../../../../system";

const RefundPolicy = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [refundPolicyData, setRefundPolicyData] = useState([]);

  const refundPolicy = useSelector(
    (state) => state.refundPolicy.RefundPolicyData
  );

  useEffect(() => {
    if (refundPolicy?.data) {
      setRefundPolicyData(refundPolicy.data);
      reset(
        refundPolicy.data.reduce((acc, item) => {
          acc[`daysPrior_${item.id}`] = item.daysPrior;
          return acc;
        }, {})
      );
    }
  }, [refundPolicy, reset]);

  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });

  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    dispatch(RefundPolicyActions.getRefundPolicy());
  }, [dispatch]);

  const handleEditClick = () => {
    setEditMode(true);
  };

  const handleCancelClick = () => {
    setEditMode(false);
    reset(
      refundPolicy.data.reduce((acc, item) => {
        acc[`daysPrior_${item.id}`] = item.daysPrior;
        return acc;
      }, {})
    );
  };

  const onSubmit = (data) => {
    const transformedData = refundPolicyData.map((item) => ({
      ...item,
      daysPrior: data[`daysPrior_${item.id}`],
    }));
    dispatch(RefundPolicyActions.updateRefundPolicy(transformedData));
    setEditMode(false);
  };

  return (
    <>
      <div className="row p-md-5 p-3 py-md-3 py-5 refundPolicy d-flex flex-column justify-content-between">
        <div>
          <div className="col-12">
            <div className="d-flex justify-content-between">
              <h1 className="fw-bolder py-1 fs-35">
                {t(translationConstants.REFUND_POLICY)}
              </h1>
              {!editMode && (
                <div className="ms-2 d-flex justify-content-center align-items-center">
                  <span className="fw-medium fs-5 sub-heading-color">
                    {t(translationConstants.edit)}
                  </span>
                  <div className="cursor-pointer" onClick={handleEditClick}>
                    <svg
                      width="35"
                      height="35"
                      viewBox={
                        direction === Direction.RTL
                          ? "22 2 20 11"
                          : "20 0 20 16"
                      }
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M36.4449 13.2687V9.53359H35.3778V13.2687H26.8403V4.73125H30.5754V3.66406H26.8403C26.2509 3.66406 25.7731 4.14186 25.7731 4.73125V13.2687C25.7731 13.8581 26.2509 14.3359 26.8403 14.3359H35.3778C35.9671 14.3359 36.4449 13.8581 36.4449 13.2687ZM34.9392 4.05008C34.6946 3.80355 34.3597 3.66406 34.0103 3.66406C33.6614 3.66406 33.3268 3.80324 33.0808 4.05072L28.6153 8.51625C28.2162 8.86785 27.9546 9.39104 27.9092 9.95369L27.9074 11.6692V12.2028H30.1136C30.7189 12.1613 31.2472 11.8971 31.6199 11.4672L36.0602 7.02882C36.3066 6.78247 36.445 6.44835 36.445 6.09996C36.445 5.75157 36.3066 5.41745 36.0602 5.1711L34.9392 4.05008ZM30.076 11.1359C30.3611 11.1157 30.6264 10.9831 30.8395 10.7393L34.075 7.50381L32.6054 6.03405L29.3461 9.29222C29.1299 9.48342 28.9962 9.75092 28.9747 9.99562V11.1349L30.076 11.1359ZM33.3601 5.27956L34.8296 6.7492L35.3057 6.27316C35.3519 6.22695 35.3778 6.16427 35.3778 6.09892C35.3778 6.03357 35.3519 5.97089 35.3057 5.92468L34.1832 4.80217C34.1375 4.75611 34.0753 4.73021 34.0104 4.73021C33.9455 4.73021 33.8833 4.75611 33.8376 4.80217L33.3601 5.27956Z"
                        fill="#2C7465"
                      />
                    </svg>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="col-md-5 col-12">
            <div className="row">
              <div className="col-6">
                <h4 className="fw-bold fs-18">
                  {t(translationConstants.REFUND_TYPE)}
                </h4>
              </div>
              <div className="col-6 d-flex align-items-center">
                <h4 className="text-md-left text-center fs-18">
                  <span className="fw-bold">
                    {t(translationConstants.DAYS)}
                  </span>{" "}
                  {"("}
                  {t(translationConstants.PRIOR)}
                  {")"}:
                </h4>
              </div>
            </div>
            {refundPolicyData.map((item) => (
              <div key={item.id} className="row">
                <div className="col-6 fw-medium fs-14 py-2">{t(translationConstants.ID)}:{item.id}{" - "}{item.type}%</div>
                <div className="col-6 py-2 fs-14 d-flex justify-content-md-start justify-content-center">
                  <Controller
                    name={`daysPrior_${item.id}`}
                    control={control}
                    defaultValue={item.daysPrior}
                    rules={{
                      required: t(translationConstants.FIELD_IS_REQUIRED),
                      min: {
                        value: 0,
                        message: t(translationConstants.MUST_BE_NON_NEGATIVE),
                      },
                      max: {
                        value: 100,
                        message: t(translationConstants.MUST_BE_100_OR_LESS),
                      },
                    }}
                    render={({ field }) => (
                      <input
                        {...field}
                        type="text"
                        disabled={!editMode}
                        className={
                          editMode ? "inputField" : "inputFieldDisabled"
                        }
                        onKeyDown={(e)=>allowOnlyNumbers(e)}
                      />
                    )}
                  />
                  {errors[`daysPrior_${item.id}`] && (
                    <p className="errorText">
                      {errors[`daysPrior_${item.id}`].message}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="col-12 button-group-height">
          {editMode && (
            <div className="d-flex gap-3 justify-content-center">
              <button
                className="update-btn fs-18"
                onClick={handleSubmit(onSubmit)}
              >
                {t(translationConstants.Update)}
              </button>
              <button
                className="cancel-btn ms-3 fs-18"
                onClick={handleCancelClick}
              >
                {t(translationConstants.cancel)}
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default RefundPolicy;
